import customerOrderReviews_en from './customerOrderReviews_en';

const enLocales = { ...customerOrderReviews_en };
const enLocaleContext = require.context('./en-US', false, /\.js$/);
enLocaleContext.keys().forEach((file) => {
  const moduleLocale = enLocaleContext(file).default;
  Object.assign(enLocales, moduleLocale);
});
export default enLocales;
